(() => {
  const controllers = new WeakMap();

  class SignatureJourney {
    constructor(root) {
      this.root = root;
      this.tabs = [...root.querySelectorAll('[data-signature-tab]')];
      this.panels = [...root.querySelectorAll('[data-signature-panel]')];
      this.images = [...root.querySelectorAll('[data-signature-image]')];
      this.counter = root.querySelector('[data-signature-counter]');
      this.progress = root.querySelector('[data-signature-progress]');
      this.active = 0;
      this.animationEnabled = root.dataset.animationEnabled === 'true';
      this.abortController = new AbortController();
      this.bind();
      this.root.classList.add('is-enhanced');
      if (!this.animationEnabled) this.root.style.setProperty('--asj-duration', '1ms');
      this.activate(0, false);
      this.preload(1);
    }

    bind() {
      const signal = this.abortController.signal;
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index), { signal });
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index), { signal });
      });
    }

    onKeydown(event, index) {
      let next = index;
      if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
      else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = this.tabs.length - 1;
      else return;
      event.preventDefault();
      this.tabs[next].focus();
      this.select(next);
    }

    select(index) {
      this.activate(index, true);
    }

    activate(index, userInitiated) {
      if (index < 0 || index >= this.tabs.length) return;
      this.active = index;
      this.tabs.forEach((tab, tabIndex) => {
        const selected = tabIndex === index;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      this.images.forEach((image, imageIndex) => image.classList.toggle('is-active', imageIndex === index));
      this.panels.forEach((panel, panelIndex) => {
        const selected = panelIndex === index;
        panel.classList.toggle('is-active', selected);
        panel.hidden = !selected;
      });
      if (this.counter) this.counter.textContent = `0${index + 1} / 03`;
      if (this.progress) this.progress.style.width = `${((index + 1) / this.tabs.length) * 100}%`;
      if (userInitiated) this.preload(index + 1);
    }

    preload(index) {
      if (index < 0 || index >= this.images.length) return;
      const image = this.images[index].querySelector('img');
      if (!image || image.complete) return;
      const preload = new Image();
      preload.src = image.currentSrc || image.src;
    }

    destroy() {
      this.abortController.abort();
      this.root.classList.remove('is-enhanced');
      this.panels.forEach((panel) => { panel.hidden = false; });
    }
  }

  const init = (scope = document) => {
    scope.querySelectorAll('[data-signature-journey]').forEach((root) => {
      if (controllers.has(root)) return;
      controllers.set(root, new SignatureJourney(root));
    });
  };

  const destroy = (scope) => {
    scope.querySelectorAll('[data-signature-journey]').forEach((root) => {
      const controller = controllers.get(root);
      if (!controller) return;
      controller.destroy();
      controllers.delete(root);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
  document.addEventListener('shopify:section:select', (event) => init(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const root = event.target.closest('[data-signature-journey]');
    if (!root) return;
    const controller = controllers.get(root);
    const panel = event.target.closest('[data-signature-panel]');
    if (controller && panel) controller.activate(Number(panel.dataset.signaturePanel), false);
  });
})();
